module.exports = __webpack_public_path__ + "img/Resort - Panchgani-min.5eaa8811.jpg";